import React from "react";
export const TableIcon = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="17" height="15" rx="3.5" stroke="#9FA0B0" />
    <path
      d="M12.5 1V15"
      stroke="#9FA0B0"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 7.5L17 7.5"
      stroke="#9FA0B0"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
